import { useEffect } from "react"

import useMediaQuery from "@mobi/hooks/useMediaQuery"

const useProposal = ({ pageContext }) => {
  const isMobile = useMediaQuery("mobile")

  const adjustBackToHomeScreenButton = () => {
    if (isMobile) {
      const element = document.querySelector("button.ds-header__button-back")
      if (!element) return
      element.setAttribute("aria-label", "voltar para o início")
    } else {
      const element = document.querySelector("a.ds-header__button-back")
      if (!element) return
      element.setAttribute("role", "button")
    }
  }

  useEffect(() => {
    adjustBackToHomeScreenButton()
  }, [isMobile])

  const { currentFlow } = pageContext
  const initialStepData = {
    currentFlow
  }

  return {
    initialStepData
  }
}

export default useProposal
